import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature (influencer programme): old links go somewhere useful. Data is kept.
export const Route = createFileRoute("/partner")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true, statusCode: 301 });
  },
});
